module.exports = __webpack_public_path__ + "static/logo-fc33fa12e4bb2fdec62a269480f44036.svg";